import React from "react";
import { Box, Button, Heading, Text } from "@catchoftheday/cg-components";
import { HOTLINE_ONEPASS } from "../../../consts";
import { OnePassModal } from "../OnePassModal";
export const CancellationModal = ({ isOpen, loading, onClose, onConfirm, }) => {
    return (<OnePassModal isOpen={isOpen} onRequestClose={onClose} contentProps={{
            height: "auto",
        }} loading={loading}>
      <Box fontFamily="onePass" color="onePass.textPrimary" visibility={loading ? "hidden" : "visible"}>
        <Heading.h3 fontWeight="bold" mt={0} mb={{
            xs: 8,
            md: 6,
        }}>
          Important: Your OnePass Subscription
        </Heading.h3>
        <Text mt={0} mb={{
            xs: 12,
            md: 8,
        }} fontSize="base" fontWeight="medium">
          Looks like you had two active subscriptions with OnePass.
          <br />
          <br />
          We&apos;ve fixed this to ensure you will be billed correctly, so you
          can continue enjoying your benefits.
          <br />
          <br />
          If you have any further queries, please reach out to our customer
          service team {HOTLINE_ONEPASS}.
        </Text>
        <Button variant="onePassPrimary" width={{ xs: "100%", md: "50%" }} onClick={onConfirm} fontWeight="semibold">
          Got it
        </Button>
      </Box>
    </OnePassModal>);
};
